export const ADMIN_ROLE = 'admin';
export const STUDENT_ROLE = 'student';
